/**
 * 单独书写的校验要求
 * author:brian author 2022 05 20
 */

export let channelMask = function (rules, value, callback) {

    const reg = /^\d+([,]\d+)*$/;
    if (!reg.test(String(value))) {
        callback(new Error($t('integration.multiple_combined_numbers_are_separated_by_commas_and_are_numbers')))
    } else {
        let array = value.split(',');
        for (let item of array) {
            if (parseInt(item) > 255 || parseInt(item) < 1) {
                callback('存在不在1-255范围的值')
            }
        }
        callback();
    }

};
export let checkNumber = function (rules, value, callback) {
    // let reg = /^\+?[1-9]\d{0,7}(\.\d*)?$/
    let reg = /^\d{1,}$/
    if (parseInt(value) > 16777215 || parseInt(value) < 1) {
        callback('范围值在1-167771215')
    } else if (!reg.test(value)) {
        callback($t('integration.only_numbers_can_be_entered'))
    } else {
        callback()
    }
};
export let EnNumber = function (rules, value, callback) {
    let reg = /^[A-Za-z0-9]+$/;
    if (!reg.test(value)) {
        callback(new Error($t('integration.only_english_or_numbers_can_be_entered')))
    } else {
        callback();
    }
}